import { observable } from "mobx";
import { api, api_adm } from "../../api";
import { IProduto } from "../../model";
import { decodeUtf8String, downloadBinaryFile } from "../../utils";
import { toast } from "react-toastify";

class _UtilitarioStore {

  obs = observable({
    file_name: "Selecione um arquivo CSV",
    loading_equaliza_ncm: false,
    open_equaliza_ncm: false,
  })

  async handleEqualizaNcm(data) {

    let resp = await api_adm.post("/api/admin/equaliza-ncm", data, { responseType: 'blob' })

    if (resp.status == 200) {

      let filename = "retorno.xlsx"

      downloadBinaryFile(resp.data, filename)

    } else {

      toast.error(decodeUtf8String(resp.headers.msg), {});

    }

  }

}

export const UtilitarioStore = new _UtilitarioStore();
